export default __webpack_public_path__ + "static/media/arrow_forward_ios_white_24dp.5051f98a.svg";